import { useOnSubmissionStateChangedSubscription, type useOpportunitiesQuery } from "@qw/graphql";
import { useConversation } from "@/providers/use-conversation";
import { LinkSubmissionButton } from "../components/link-submission-button";
import { Row } from "../components/row";
import { UnlinkSubmissionButton } from "../components/unlink-submission-button";
import { SubmissionMenu } from "./submission-menu";
import type { RailSubmission } from "./use-submission-actions";

export const ActiveSubmission = ({
  insuredId,
  linkedId,
  liveUpdates = true,
  refetch,
  submission,
}: {
  insuredId: string;
  linkedId?: string;
  liveUpdates?: boolean;
  refetch: ReturnType<typeof useOpportunitiesQuery>["refetch"];
  submission: RailSubmission;
}) => {
  const { inboxConversation } = useConversation();

  useOnSubmissionStateChangedSubscription({
    onData: () => refetch(),
    skip: !liveUpdates || !submission.id,
    variables: { id: submission.id || "" },
  });

  const conversationId = inboxConversation?.id || "";

  const { appetiteProduct, state } = submission;

  const isLinked = linkedId === submission.id;
  const disabled = !!linkedId && !isLinked;

  return (
    <Row
      state={state}
      button={
        <div className="flex items-center gap-0.5">
          {conversationId && isLinked ? (
            <UnlinkSubmissionButton conversationId={conversationId} submissionId={submission.id} />
          ) : !disabled && !isLinked ? (
            <LinkSubmissionButton conversationId={conversationId} submissionId={submission.id} />
          ) : null}
          <SubmissionMenu insuredId={insuredId} submission={submission} />
        </div>
      }
      className="bg-transparent border-0 hover:bg-muted/40 items-center py-2 rounded-none shadow-none"
    >
      <span className="font-medium truncate">{appetiteProduct.carrierName}</span>
      <span className="text-muted-foreground truncate">{appetiteProduct.carrierProductName || ""}</span>
    </Row>
  );
};
